// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const caterpie: PokeData = {
  "id": 10,
  "name": "caterpie",
  "height": 3,
  "weight": 29,
  "base_experience": 39,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "tackle",
    "string-shot",
    "bug-bite"
  ],
  "moves": [
    "tackle",
    "string-shot",
    "bug-bite",
    "pounce",
    "infest",
    "leech-steal",
    "lunge",
    "pin-missile",
    "sticky-web",
    "signal-spam",
    "heal-order",
    "pin-rush",
    "bug-buzz"
  ],
  "evolution_chain": {
    "id": 4,
    "item": null,
    "species": [
      {
        "name": "caterpie",
        "order": 10,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "metapod",
        "order": 11,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 10,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 7,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "butterfree",
        "order": 12,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 11,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 36.25,
    "speed": 45,
    "ability_power": 30
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
